import React from 'react'

export default function SingleBetByEvent() {
  return (
    <>
        <section className="flex justify-center customFontRoboto text-xs font-bold mt-8">
        <div className="flex w-full">
            <a className="flex w-[150px] text-white pl-3 pr-8 py-2 bg-customForeColor rounded-sm" href="./ReportByEvent.html">
                <img className="h-5" src="../CustomIcons/Chevron Left.png" alt="" />
                <button className="flex justify-center items-center w-[90%]">Back</button>
            </a>
            <div className="flex w-[150px] mx-2 items-center rounded-sm bg-customTitleColor">
                <span className="flex justify-center items-center w-[90%]">Single</span>
                <img className="h-7" src="../CustomIcons/Expand Arrow.png" alt="" />
            </div>
        </div>
    </section>

     <div className="flex justify-center mt-4 h-[90vh] customFontRoboto text-[0.7rem] font-bold">
        <div className="grid grid-rows-2 h-[95%] w-full">
            <div className="grid grid-cols-[3fr,1fr] lg:grid-cols-[2fr,1fr] h-[95%] w-[100%]">
                <table className="text-customFontVoilet h-[100%] w-[100%]">
                    <tr className="flex h-12 border-y-2 border-customTitleColor">
                        <td className="py-3 w-[17%] text-center"><h1>21/05 - 03:45 PM</h1></td>
                        <td className="py-3 w-[30%] text-start"><h1>Man City</h1></td>
                        <td className="py-3 w-[10%] text-center"><h1>ttaakkpp</h1></td>
                        <td className="py-3 w-[10%] text-center"><h1>=-60</h1></td>
                        <td className="py-3 w-[15%] text-end"><h1>70,000</h1></td>
                        <td className="pl-3 py-3 w-[15%]">
                            <div className="flex justify-evenly items-center">
                                <a href="#">
                                    <img className="w-5" src="../CustomIcons/View.png" alt="" />
                                </a>
                                <a href="#">
                                    <img className="w-5" src="../CustomIcons/Unavailable.png" alt="" />
                                </a>
                                <a href="#">
                                    <img className="w-5" src="../CustomIcons/High Importance.png" alt="" />
                                </a>
                            </div>
                        </td>
                    </tr>
                </table>
                <div className="bg-cyan-600">
                    <h1>second</h1>
                </div>
            </div>
            <div className="grid grid-cols-[1fr,3fr] lg:grid-cols-[1fr,2fr] h-[95%] w-[100%]">
                <div className="bg-slate-400">
                    <h1 className="">first</h1>
                </div>
                <div>
                    <table className="text-customFontGreen h-[100%] w-[100%]">
                        <tr className="flex h-12 border-y-2 border-customTitleColor">
                            <td className="py-3 w-[17%] text-center"><h1>21/05 - 03:45 PM</h1></td>
                            <td className="py-3 w-[30%] text-start"><h1>Chelsea</h1></td>
                            <td className="py-3 w-[10%] text-center"><h1>ttaakkpp</h1></td>
                            <td className="py-3 w-[10%] text-center"><h1>=-60</h1></td>
                            <td className="py-3 w-[15%] text-end"><h1>70,000</h1></td>
                            <td className="pl-3 py-3 w-[15%]">
                                <div className="flex justify-evenly items-center">
                                    <a href="">
                                        <img className="w-5" src="../CustomIcons/View2.png" alt=""/>
                                    </a>
                                    <a href="">
                                        <img className="w-5" src="../CustomIcons/Unavailable2.png" alt="" />
                                    </a>
                                    <a href="">
                                        <img className="w-5" src="../CustomIcons/High Importance2.png" alt=""/>
                                    </a>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
         </div>
     </div>
    </>
  )
}
